// extracted by mini-css-extract-plugin
export default {"link":"BackButton_link__xnLjw","backBtn":"BackButton_backBtn__+LATV"};